import React, { memo } from 'react';
import { LayoutDefault } from '@app/layouts';
import { Container } from '@app/components';
import { SectionHeader } from './SectionHeader';
import { SectionAbout } from './SectionAbout';
import { SectionEssence } from './SectionEssence';
import { SectionFunctional } from './SectionFunctional';
import { SectionContacts } from './SectionContacts';
import { SectionRegistered } from './SectionRegistered';
import { SectionFAQ } from './SectionFAQ';

function AboutUs() {
  return (
    <LayoutDefault className="bg-[#f5f5f5] mb-[-32px]">
      <SectionHeader />
      <Container>
        <SectionAbout />
        <SectionEssence />
        <SectionFunctional />
        <SectionRegistered />
        <SectionFAQ />
        <SectionContacts />
      </Container>
    </LayoutDefault>
  );
}

export default memo(AboutUs);
